const FRESH_LOGIN_KEY = "kipabiz_fresh_login";
const ACTIVE_TAB_KEY = "kipabiz_active_tab";

const VALID_TABS = new Set([
  "dashboard",
  "chat",
  "reports",
  "ledger",
  "customers",
  "inventory",
]);

/** Set when user logs in or registers — consumed when main app opens. */
export function markFreshLogin() {
  sessionStorage.setItem(FRESH_LOGIN_KEY, "1");
}

export function consumeFreshLogin() {
  const fresh = sessionStorage.getItem(FRESH_LOGIN_KEY) === "1";
  if (fresh) sessionStorage.removeItem(FRESH_LOGIN_KEY);
  return fresh;
}

export function clearFreshLogin() {
  sessionStorage.removeItem(FRESH_LOGIN_KEY);
}

/** Restore last bottom-nav tab across browser reload (same tab session). */
export function readSavedTab(fallback = "dashboard") {
  if (typeof window === "undefined") return fallback;
  const tab = sessionStorage.getItem(ACTIVE_TAB_KEY);
  return VALID_TABS.has(tab) ? tab : fallback;
}

export function saveActiveTab(tab) {
  if (typeof window === "undefined") return;
  if (VALID_TABS.has(tab)) {
    sessionStorage.setItem(ACTIVE_TAB_KEY, tab);
  }
}

export function clearSavedTab() {
  sessionStorage.removeItem(ACTIVE_TAB_KEY);
}
